import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { ADD_LANGUAGE } from "helpers/api_endpoints";


//meta title
document.title = "Add Language";

const AddLanguage = () => {

    const [name, setname] = useState('');
    const [code, setLanguageCode] = useState('');
    const [symbol, setSymbol] = useState('');
    const [status, setStatus] = useState(0);
    const [errorMsg, seterrorMsg] = useState('');
    const navigate = useNavigate();

    const handleSubmit = () => {
        post(ADD_LANGUAGE, { name, code, symbol, status })
            .then(response => {
                if (response.code == 201) {
                    navigate('/languages', { state: { successMsg: 'Language Added SuccessFully' } });
                }
            })
            .catch(error => {
                seterrorMsg('Language Creation Failed');
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Languages" breadcrumbItem="Add Language" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Name</Trans></Label>
                                                <Input
                                                    name="name"
                                                    // value={name}
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    type="text"
                                                    onChange={(e) => setname(e.target.value)}
                                                    required ></Input>
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Language Code</Trans></Label>
                                                <Input
                                                    name="code"
                                                    // value={name}
                                                    className="form-control"
                                                    placeholder="Enter Language Code"
                                                    type="text"
                                                    onChange={(e) => setLanguageCode(e.target.value)}
                                                    required ></Input>
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Symbol</Trans></Label>
                                                <Input
                                                    name="symbol"
                                                    // value={name}
                                                    className="form-control"
                                                    placeholder="Enter Symbol"
                                                    type="text"
                                                    onChange={(e) => setSymbol(e.target.value)} required
                                                ></Input>
                                            </div>


                                            <div className="form-group col-md-4 mt-2">
                                                <Label className="form-label"><Trans>Status</Trans></Label>
                                                <select className="form-control" onChange={(e) => setStatus(e.target.value)}>
                                                    <option value=''></option>
                                                    <option value={1} selected={status == 1}><Trans>Active</Trans></option>
                                                    <option value={0} selected={status == 0}><Trans>Non Active</Trans></option>
                                                </select>
                                            </div>

                                        </Row>
                                        <div className="text-center  mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddLanguage
